import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DeveloperDocsIcon = ({
  title
}) => {
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": "vertical-nav-icon__developer-docs",
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, /*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_114_263)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M4.56616 4.36548C4.42135 4.22022 4.221 4.13049 3.99978 4.13049C3.77856 4.13049 3.57821 4.22022 3.43339 4.36548L0.234994 7.56388C0.0897329 7.7087 0 7.90905 0 8.13027C0 8.35149 0.0897329 8.55184 0.234994 8.69665L3.43339 11.8951C3.57821 12.0399 3.77856 12.1296 3.99978 12.1296C4.44222 12.1296 4.80071 11.7711 4.80071 11.3287C4.80071 11.1074 4.71098 10.9071 4.56616 10.7623L1.93192 8.12805L4.56616 5.49825C4.71142 5.35343 4.80116 5.15309 4.80116 4.93187C4.80116 4.71064 4.71142 4.5103 4.56616 4.36548V4.36548ZM12.5666 4.36548C12.4218 4.22067 12.2214 4.13093 12.0002 4.13093C11.5578 4.13093 11.1993 4.48942 11.1993 4.93187C11.1993 5.15309 11.289 5.35343 11.4338 5.49825L14.0681 8.12805L11.4338 10.7623C11.289 10.9071 11.1993 11.1074 11.1993 11.3287C11.1993 11.7711 11.5578 12.1296 12.0002 12.1296C12.2214 12.1296 12.4218 12.0399 12.5666 11.8951L15.765 8.69665C15.9103 8.55184 16 8.35149 16 8.13027C16 7.90905 15.9103 7.7087 15.765 7.56388L12.5666 4.36548ZM9.22161 2.01555C9.17408 2.00533 9.11944 2 9.06391 2C8.67788 2 8.35582 2.2732 8.28075 2.63701L8.27986 2.64235L6.14759 13.3037C6.13738 13.3512 6.13205 13.4059 6.13205 13.4614C6.13205 13.8474 6.40524 14.1695 6.76906 14.2445L6.77439 14.2454C6.79838 14.2481 6.82636 14.2494 6.85435 14.2494C6.88234 14.2494 6.91032 14.2481 6.93786 14.245L6.93431 14.2454C7.3199 14.2441 7.64107 13.9705 7.71525 13.6066L7.71614 13.6013L9.84841 2.93997C9.85641 2.89777 9.86085 2.84891 9.86085 2.79916C9.86085 2.41446 9.58898 2.09329 9.22739 2.01688L9.22206 2.01599L9.22161 2.01555Z",
        fill: "#DFE3EB"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_114_263",
        children: /*#__PURE__*/_jsx("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      })
    })]
  });
};
export default DeveloperDocsIcon;